import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import cdpService from "../../../apiService/cdp.service";
import Loader from "../../Global/Loader";

const UserBounceRateChart = ({ filters = {} }) => {
  const [userBounceData, setUserBounceData] = useState([["Month", "Bounce Rate"]]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchBounceRateData();
  }, [filters]);

  const fetchBounceRateData = async () => {
    setLoading(true);
    setError(null);

    try {
      const payload = Object.keys(filters).length > 0 ? filters : {};
      const response = await cdpService.getBounceRateChart(payload);

      if (response.data.success) {
        const bounceRateData = response.data.data.bounceRate.map((item) => [
          formatMonth(item.month),
          item.bounce_rate,
        ]);

        setUserBounceData([["Month", "Bounce Rate"], ...bounceRateData]);
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatMonth = (monthString) => {
    const date = new Date(monthString + "-01");
    return date.toLocaleString("en-US", { month: "short", year: "numeric" });
  };

  const UserBounceOptions = {
    chartArea: {
      left: 50,
      right: 30,
      bottom: 50,
      top: 30,
      width: "80%",
      height: "80%",
    },
    hAxis: {
      title: "Month",
    },
    vAxis: {
      title: "Bounce Rate (%)",
      minValue: 0,
    },
    legend: "none",
    colors: ["#FF5733"],
  };

  if (loading) return <Loader />;
  if (error) return <p className="text-red-500 text-center">{error}</p>;

  // Show "No Data" message if only header exists
  if (userBounceData.length <= 1) {
    return (
      <div className="flex justify-center items-center h-[350px] text-gray-500 text-lg font-medium">
        No data available
      </div>
    );
  }

  return (
    <Chart
      chartType="LineChart"
      width="100%"
      height="350px"
      data={userBounceData}
      options={UserBounceOptions}
    />
  );
};

export default UserBounceRateChart;
